import React, { useEffect, useState } from 'react';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import { toast } from 'react-toastify';
import { BiNotepad, BiRefresh } from 'react-icons/bi';
import ShowModal from '../../utils/ShowModal';
import DatePicker from '../../components/inputFields/DatePicker';
import SearchBar from '../../components/searchBar/SearchBar';
import { getWebEnquiries, patchWebEnquiry } from '../../services/enquiries';
import { formatDateTime } from '../../utils/FormatDateTime';
import AddWebEnquiryNote from './AddWebEnquiryNote';
import Dropdown from '../../components/inputFields/DropDown';

function AppEnquiries() {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [openingItem, setOpeningItem] = useState({});

    const [searchText, setSearchText] = useState("");
    const [filterDate, setFilterDate] = useState(new Date().toISOString().split('T')[0]);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "Attended", key: "attended" },
        { label: "Visit Time", key: "created_at" },
        { label: "Name", key: "name" },
        { label: "Status", key: "status" },
        { label: "Product", key: "product_name" },
        { label: "Phone", key: "phone_number" },
        { label: "Address", key: "address" },
        { label: "Note", key: "note" },
    ];

    const pageSize = 50;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getWebEnquiries(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data)
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`date=${filterDate}`);
    }, []);

    // Open modal with the selected PDF ID
    const openModal = (item) => {
        setOpeningItem(item);
        setIsOpen(true);
    };

    // Close modal
    const closeModal = () => {
        setIsOpen(false);
        setOpeningItem({});
    };

    const onSave = () => {
        fetchData();
        closeModal();
    };

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData(`user=${query}&date=${filterDate}`);
    };

    const handleDateChange = (value) => {
        setFilterDate(value);
        fetchData(`user=${searchText}&date=${value}`);
    };


    const resetFilters = () => {
        setSearchText("");
        setFilterDate("");
        fetchData("");
    };

    const handleRowStatusChange = async (item, value) => {
        try {
            const data = {
                status: value,
            };
            let res = await patchWebEnquiry({
                data: data,
                id: item.id,
            });
            if (res.status === 200) {
                toast.success("Status Updated");
                fetchData(`user=${searchText}&date=${filterDate}`);
            } else {
                toast.error("Unable to Update Status");
            }
        } catch (error) {
            console.error("Error in Orders:", error);
        }
    };

    return (<>
        <div className="flex flex-row gap-2 items-center">
            <SearchBar
                placeholder="Search for Number/ Name"
                onSearch={handleSearch}
                value={searchText}
            />

            {/* Date Picker */}
            <DatePicker
                value={filterDate}
                onChange={handleDateChange}
                placeholder="Date"
            />
            {/* Reset Filters Icon */}
            {(searchText.length !== 0 || filterDate.length !== 0) && (
                <BiRefresh
                    size={24}
                    className="cursor-pointer text-primary"
                    onClick={resetFilters}
                />
            )}
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                attended: <div className={`w-4 aspect-square rounded-full ${item.note && item.note.length !== 0 ? "bg-primary" : "bg-red-700"}`}></div>,
                                name: <p>{item.name}</p>,
                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                status: <Dropdown
                                    name="status"
                                    options={[
                                        { label: "Pending", value: "pending" },
                                        { label: "In Progress", value: "in_progress" },
                                        { label: "Completed", value: "completed" },
                                        { label: "Cancelled", value: "cancelled" },
                                    ]}
                                    placeholder={item.status}
                                    onChange={(value) => handleRowStatusChange(item, value)}
                                />,
                                product_name: <p className="max-w-48 truncate cursor-help" title={item.product_name}>{item.product_name}</p>,
                                address: <p className="max-w-48 truncate cursor-help" title={item.address}>{item.address}</p>,
                                phone_number: <p>{item.phone_number}</p>,
                                note: <BiNotepad size={24} color='green' onClick={() => openModal(item)} className='cursor-pointer' />,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}
                    
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
        <ShowModal contentLabel={"Note alert"} isOpen={modalIsOpen} modalWidth="50%" isSidebar={true} onRequestClose={closeModal} componentToPass={<AddWebEnquiryNote item={openingItem} onSave={onSave} />} />
    </>);
}

export default AppEnquiries;